export default function FullyCheckedIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.4 10.846L5 12.194L10 17L19 8.346L17.6 7L10 14.308L6.4 10.846ZM19 21H5C3.895 21 3 20.105 3 19V5C3 3.896 3.895 3 5 3H19C20.104 3 21 3.896 21 5V19C21 20.105 20.104 21 19 21Z"
        fill="currentColor"
      />
    </svg>
  );
}
